import styled from '@emotion/styled';

export const MessageWrapper = styled.div`
  padding: 60px 0;
`;

export const DataTableContainer = styled.div`
  .rdt_TableRow:hover {
    cursor: pointer;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  display: flex;
  justify-content: space-between;
`;
